import { gql, useMutation } from '@apollo/client'
import { remove } from 'ramda'
import { useAlert } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import { generalClient } from '../../../../utils/apollo/api'
import { useCloseModal, useModalData } from '../../../../components/modals/ModalsContext'
import { useScreen } from '../_load/ScreenLoader'

const MUTATION = gql`
  mutation UpsertScreen($input: ScreenInput) {
    upsertScreen(input: $input) {
      id
    }
  }
`

const cleanRequest = (col, screen, index) => ({
  id: screen.id,
  data: JSON.stringify({
    ...screen.data,
    columns: remove(index, 1, screen.data?.columns || [])
  })
})

export const useRemoveColumn = () => {
  const closeModal = useCloseModal()
  const screen = useScreen()
  const { index } = useModalData() || {}
  const modal = useAlert()
  const { t } = useTranslation('common')

  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Screen'], client: generalClient })

  const handleRequest = (form, actions) => {
    if (!modal.confirm({ title: t('confirmRemove') })) return false
    const input = cleanRequest(form, screen, index)

    return request({ variables: { input } }).then(resp => {
      if (!resp.errors) {
        closeModal()
      }
    })
  }

  return [handleRequest, state]
}
